function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

if ($('html').attr('lang') === 'ru') {
    window.lang_verification = {
        'upload_error': 'Ошибка загрузки'
    };
}else{
    window.lang_verification = {
        'upload_error': 'File upload error'
    };
}

$('.row.cpc1 .file_loader').fileupload({
  acceptFileTypes: /(\.|\/)(jpe?g|png|gif)$/i,
  maxFileSize: 12000000,
  multiple: false,
  dataType: 'json',
  single: true,
  fileInput: $('.row.cpc1 .file_loader'),
  dropZone: $('.row.cpc1'),
  add: function add(e, data) {
	data.url=$(this).attr('data-path');
	$('.verified').remove();
	  //console.log($(this),$(this).attr('data-path'));
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploaded').addClass('uploading').removeAttr('style');
    $(this).next().val('');
    data.submit();
  },
  done: function done(e, data) {
    console.log(data.result);
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').addClass('uploaded');
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").css({
      'background-image': 'url(' + data.result.url + '?rand' + getRandomInt(0,999999999) + ')'
    });
	 $("[data-retarget='"+("#"+$(this).prop('id'))+"']").attr('loaded',true);
    $(this).next().val(data.result.path);
  },
  progressall: function progressall(e, data) {
    var progress = parseInt(data.loaded / data.total * 100, 10);
  },
  fail: function fail(e, data) {
    try {
      console.log(data, data.jqXHR, data.jqXHR.responseJSON);
      swal({
        text: data.jqXHR.responseJSON.errors.file[0],
        icon: 'error'
      }).then(function () {});
    } catch (e) {
      swal({
        text: lang_verification.upload_error,
        icon: 'error'
      }).then(function () {});
    }

    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').removeClass('uploaded').removeAttr('style');
  }
});
$('.row.cpc2 .file_loader').fileupload({
  acceptFileTypes: /(\.|\/)(jpe?g|png|gif)$/i,
  maxFileSize: 12000000,
  multiple: false,
  dataType: 'json',
  single: true,
  fileInput: $('.row.cpc2 .file_loader'),
  dropZone: $('.row.cpc2'),
  add: function add(e, data) {
	data.url=$(this).attr('data-path');
	$('.verified').remove();
	  //console.log($(this),$(this).attr('data-path'));
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploaded').addClass('uploading').removeAttr('style');
    $(this).next().val('');
    data.submit();
  },
  done: function done(e, data) {
    console.log(data.result);
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').addClass('uploaded');
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").css({
      'background-image': 'url(' + data.result.url + '?rand' + getRandomInt(0,999999999) + ')'
    });
	 $("[data-retarget='"+("#"+$(this).prop('id'))+"']").attr('loaded',true);
    $(this).next().val(data.result.path);
  },
  progressall: function progressall(e, data) {
    var progress = parseInt(data.loaded / data.total * 100, 10);
  },
  fail: function fail(e, data) {
    try {
      console.log(data, data.jqXHR, data.jqXHR.responseJSON);
      swal({
        text: data.jqXHR.responseJSON.errors.file[0],
        icon: 'error'
      }).then(function () {});
    } catch (e) {
      swal({
        text: lang_verification.upload_error,
        icon: 'error'
      }).then(function () {});
    }

    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').removeClass('uploaded').removeAttr('style');
  }
});
$('.row.cpc3 .file_loader').fileupload({
  acceptFileTypes: /(\.|\/)(jpe?g|png|gif)$/i,
  maxFileSize: 12000000,
  multiple: false,
  dataType: 'json',
  single: true,
  fileInput: $('.row.cpc3 .file_loader'),
  dropZone: $('.row.cpc3'),
  add: function add(e, data) {
	data.url=$(this).attr('data-path');
	$('.row.cpc3').find('.verify.verified').remove();
	  //console.log($(this),$(this).attr('data-path'));
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploaded').addClass('uploading').removeAttr('style');
    $(this).next().val('');
    data.submit();
  },
  done: function done(e, data) {
    console.log(data.result);
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').addClass('uploaded');
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").css({
      'background-image': 'url(' + data.result.url + '?rand' + getRandomInt(0,999999999) + ')'
    });
	 $("[data-retarget='"+("#"+$(this).prop('id'))+"']").attr('loaded',true);
    $(this).next().val(data.result.path);
  },
  progressall: function progressall(e, data) {
    var progress = parseInt(data.loaded / data.total * 100, 10);
  },
  fail: function fail(e, data) {
    try {
      console.log(data, data.jqXHR, data.jqXHR.responseJSON);
      swal({
        text: data.jqXHR.responseJSON.errors.file[0],
        icon: 'error'
      }).then(function () {});
    } catch (e) {
      swal({
        text: lang_verification.upload_error,
        icon: 'error'
      }).then(function () {});
    }

    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').removeClass('uploaded').removeAttr('style');
  }
});
$('.row.cpc4 .file_loader').fileupload({
  acceptFileTypes: /(\.|\/)(jpe?g|png|gif)$/i,
  maxFileSize: 12000000,
  multiple: false,
  dataType: 'json',
  single: true,
  fileInput: $('.row.cpc4 .file_loader'),
  dropZone: $('.row.cpc4'),
  add: function add(e, data) {
	data.url=$(this).attr('data-path');
	$('.row.cpc4').find('.verify.verified').remove();
	  //console.log($(this),$(this).attr('data-path'));
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploaded').addClass('uploading').removeAttr('style');
    $(this).next().val('');
    data.submit();
  },
  done: function done(e, data) {
    console.log(data.result);
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').addClass('uploaded');
    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").css({
      'background-image': 'url(' + data.result.url + '?rand' + getRandomInt(0,999999999) + ')'
    });
	 $("[data-retarget='"+("#"+$(this).prop('id'))+"']").attr('loaded',true);
    $(this).next().val(data.result.path);
  },
  progressall: function progressall(e, data) {
    var progress = parseInt(data.loaded / data.total * 100, 10);
  },
  fail: function fail(e, data) {
    try {
      console.log(data, data.jqXHR, data.jqXHR.responseJSON);
      swal({
        text: data.jqXHR.responseJSON.errors.file[0],
        icon: 'error'
      }).then(function () {});
    } catch (e) {
      swal({
        text: lang_verification.upload_error,
        icon: 'error'
      }).then(function () {});
    }

    $("[data-retarget='"+("#"+$(this).prop('id'))+"']").removeClass('uploading').removeClass('uploaded').removeAttr('style');
  }
});
function error_msg(error){
	swal({
		text: error,
		icon: 'error'
	}).then(function () {});
}


$('#form1').removeAttr('onsubmit').submit(function(event) {
	var a = $('[data-retarget="#upload_webinar_image1"]')[0].hasAttribute("loaded");
	var b = $('[data-retarget="#upload_webinar_image2"]')[0].hasAttribute("loaded");
	var c = $('[data-retarget="#upload_webinar_image3"]')[0].hasAttribute("loaded");
	var d = $('[data-retarget="#upload_webinar_image4"]')[0].hasAttribute("loaded");

	var phoneNumber = $('[name="phone_number"]').val();

	if (!c && !d && !a) {
        event.preventDefault();
        error_msg($('[data-retarget="#upload_webinar_image1"]').data('errormsg'));
    } else if(!c && !d && !b) {
        event.preventDefault();
        error_msg($('[data-retarget="#upload_webinar_image2"]').data('errormsg'));
    }else if ((a && !b) || (b && !a)){
	    if(!a){
            event.preventDefault();
            error_msg($('[data-retarget="#upload_webinar_image1"]').data('errormsg'));
        }else if(!b){
            event.preventDefault();
            error_msg($('[data-retarget="#upload_webinar_image2"]').data('errormsg'));
        }
	}else if(phoneNumber.length === 0){
		event.preventDefault();
		error_msg($('[name="phone_number"]').data('errormsg'));
	}
//	$(this).submit();
  //var button = event.submittedVia;
});
